import React from 'react'

function Ratrappage() {
  return (
    <div className='messageriebox'>
        
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Avis de rattrapages</p>
        <hr/> 
       
      
    </div>
  )
}

export default Ratrappage